import PropTypes from 'prop-types';

import { Button } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  lengthValidation50,
  lengthValidation200,
  maxFileSize,
  required,
} from '../Forms/utils';

import {
  CHECKBOX,
  EXPANDABLE_IMAGE_COMPONENT,
  IMAGE_UPLOAD,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const RemoteDoormanPopUpComponent = (props) => {
  const { t } = useTransl();
  const { form, onSubmit, initialValues, isUpdate, onDeletePopUp } = props;
  const { photo } = initialValues;
  const { url: imageSrc } = photo || {};
  const formData = [
    {
      keyName: 'headline',
      label: t('remoteDoorman.headLineText'),
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation50],
    },
    {
      keyName: 'body',
      label: t('remoteDoorman.bodyText'),
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [required, lengthValidation200],
    },
    {
      keyName: 'icon',
      label: t('title.icon'),
      fieldType: EXPANDABLE_IMAGE_COMPONENT,
      src: imageSrc,
      height: '10rem',
      isHidden: !imageSrc,
    },
    {
      keyName: 'image',
      label: t('title.image'),
      fieldType: IMAGE_UPLOAD,
      validate: [maxFileSize],
      disabled: false,
    },
    {
      label: t('actions.deleteImage'),
      keyName: 'isDeleteImage',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !imageSrc,
    },
  ];

  const DeletePopUpButton = () =>
    isUpdate ? (
      <Button
        variant="contained"
        color="secondary"
        disableElevation
        onClick={onDeletePopUp}
      >
        {t('buildingSettings.deletePopup')}
      </Button>
    ) : null;

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      title={
        isUpdate
          ? t('buildingSettings.updatePopup')
          : t('buildingSettings.createPopup')
      }
      backButton={false}
      CustomComponent={DeletePopUpButton}
      isFullWidthForm
    />
  );
};

RemoteDoormanPopUpComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  isUpdate: PropTypes.bool.isRequired,
  onDeletePopUp: PropTypes.func.isRequired,
};

export default RemoteDoormanPopUpComponent;
